import { useEffect } from "react"

// Hidden field that aligns with FormElem by invoking onChange(handleInput)
// instead of writing to the store directly.
const Hidden = ({ id, useStore, statePath, localState, onChange }) => {
    // Subscribe only to the source value to mirror (e.g., 'currency')
    const [sourceValue] = useStore(s => s[statePath])


    const [state] = useStore(s => s)

    useEffect(() => {
        if (typeof onChange !== 'function') return
        if (!statePath) return

        // Avoid firing if undefined or already in sync
        if (typeof sourceValue === 'undefined') return
        if (sourceValue === localState) return

        // Trigger FormElem.handleInput with a synthetic event
        onChange({ target: { name: id, value: sourceValue } })
    }, [sourceValue, localState, id, onChange, statePath])

    return null
}

export default Hidden